<template>
    <PWAPromptAndro/>
  <PWAPromptios :copyBody="'Add Palaxi cinemas to your homescreen'" />
  <nav class="mobile-menu" >
    <div class="inner">
      <div class="mobile-search">
        <h6>Type movie or tv show name to find it</h6>
        <form>
          <input type="search" placeholder="Search here" />
          <input type="submit" value="FIND" />
        </form>
      </div>
      <!-- end mobile-search -->
      <a href="#" class="button-account"
        ><i class="lni lni-user"></i> ACCOUNT
      </a>
      <!-- end button-account -->
      <div class="site-menu">
        <ul>
          <li><a style="font-size: 5vw" href="#">HOME</a></li>
          <li><a style="font-size: 5vw" href="about.html">ABOUT US </a></li>
          <li><a style="font-size: 5vw" href="contact.html">CONTACT US</a></li>
        </ul>
      </div>
      <!-- end site-menu -->
    </div>
    <!-- end inner -->
  </nav>
  <!-- end mobile-menu -->
  <nav class="navbar" style="padding: 30px,60px;">
    <div class="logo">
      <a href="#" @click="$router.push('/index')">
        <img :src="imgPath+'images/logo.png'" alt="Image" style="height: 80px" />
      </a>
    </div>
    <!-- end logo -->
    <div class="site-menu">
      <ul>
        <li><router-link to="/index" >HOME</router-link></li>
        <li><router-link to="/about" >ABOUT US</router-link></li>
        <li><router-link to="/index#movies">MOVIES</router-link></li>
        <!--      <li><a href="#">
SHOW TIMES </a></li> -->
        <li><router-link to="/index#movies"> COMING SOON </router-link></li>
        <li><router-link to="/contactus">CONTACT US</router-link></li>
      </ul>
    </div>
    <!-- end site-menu -->
    <div class="user-menu">
      <!-- end navbar-search -->
      <!-- end navbar-notify -->
      <div class="navbar-account" v-if="loginCode">
        <router-link to="/user">Profile <i class="lni lni-user"></i> </router-link>
      </div>
      <!-- <button data-toggle="modal" data-target="#largeModal" class="tim goScreen bg4 text-center tibtn">click</button> -->
      <div class="navbar-account" v-if="!loginCode">
        <a  data-toggle="modal" data-target="#largeModall">Login <i class="lni lni-user"></i> </a>
      </div>
      <!-- end navbar-account -->
    </div>
    <!-- end user-menu -->
    <div class="hamburger-menu">
      <button class="hamburger">
        <svg width="45" height="45" viewBox="0 0 100 100">
          <path
            class="line line1"
            d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
          />
          <path class="line line2" d="M 20,50 H 80" />
          <path
            class="line line3"
            d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
          />
        </svg>
      </button>
    </div>
    <!-- end hamburger-menu -->
  </nav>
  <!-- end navbar -->
  <section class="search-box">
    <div class="container">
      <h6>Type movie or tv show name to find it</h6>
      <form>
        <input type="search" placeholder="Search here" />
        <input type="submit" value="FIND" />
      </form>
      <ul>
        <li><a href="#">Pulp Function</a></li>
        <li><a href="#">Henry Porter</a></li>
        <li><a href="#">The Racer</a></li>
      </ul>
    </div>
    <!-- end container -->
  </section>
<modal></modal>
</template>
<script>
import PWAPromptAndro  from "./PWAPrompt.vue";
import PWAPromptios from 'vue2-ios-pwa-prompt';
import modal from "../UI/LoginModal.vue";
export default {
  components:{
    modal,
    PWAPromptAndro,
    PWAPromptios
  },
  data() {
    return {
      imgPath: process.env.BASE_URL,
      loginCode:localStorage.getItem("loginCode"),
      
    }},



};
</script>
